export const GET_PLACEMENTS = 'GET_PLACEMENTS'
export const SET_PLACEMENT_SELECTED = 'SET_PLACEMENT_SELECTED'
